"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureValueFilterDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var Dropdown_1 = require("./Dropdown");
var getFilterValue = function (filter) {
    if (!filter) {
        return {};
    }
    var condition = sdk_model_1.measureValueFilterCondition(filter);
    if (!condition) {
        return {};
    }
    return sdk_model_1.isRangeCondition(condition)
        ? { from: condition.range.from, to: condition.range.to }
        : { value: condition.comparison.value };
};
var getTreatNullAsZeroValue = function (filter, treatNullAsZeroDefaultValue) {
    if (!filter || !sdk_model_1.measureValueFilterCondition(filter)) {
        return treatNullAsZeroDefaultValue !== undefined && treatNullAsZeroDefaultValue;
    }
    var condition = sdk_model_1.measureValueFilterCondition(filter);
    return ((sdk_model_1.isComparisonCondition(condition) && condition.comparison.treatNullValuesAs !== undefined) ||
        (sdk_model_1.isRangeCondition(condition) && condition.range.treatNullValuesAs !== undefined) ||
        false);
};
/**
 * @beta
 */
var MeasureValueFilterDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(MeasureValueFilterDropdown, _super);
    function MeasureValueFilterDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onApply = function (operator, value, treatNullValuesAsZero) {
            var _a, _b, _c;
            var _d = _this.props, filter = _d.filter, measureIdentifier = _d.measureIdentifier, onApply = _d.onApply;
            if (operator === null || operator === "ALL") {
                onApply(null);
            }
            else {
                if (sdk_model_1.isRangeConditionOperator(operator)) {
                    onApply(sdk_model_1.newMeasureValueFilter({ localIdentifier: measureIdentifier } || filter.measureValueFilter.measure, operator, (_a = value.from) !== null && _a !== void 0 ? _a : 0, (_b = value.to) !== null && _b !== void 0 ? _b : 0, treatNullValuesAsZero ? 0 : undefined));
                }
                else {
                    onApply(sdk_model_1.newMeasureValueFilter({ localIdentifier: measureIdentifier } || filter.measureValueFilter.measure, operator, (_c = value.value) !== null && _c !== void 0 ? _c : 0, treatNullValuesAsZero ? 0 : undefined));
                }
            }
        };
        return _this;
    }
    MeasureValueFilterDropdown.prototype.render = function () {
        var _a = this.props, filter = _a.filter, onCancel = _a.onCancel, usePercentage = _a.usePercentage, warningMessage = _a.warningMessage, locale = _a.locale, anchorEl = _a.anchorEl, separators = _a.separators, displayTreatNullAsZeroOption = _a.displayTreatNullAsZeroOption, treatNullAsZeroDefaultValue = _a.treatNullAsZeroDefaultValue, enableOperatorSelection = _a.enableOperatorSelection;
        return (react_1.default.createElement(Dropdown_1.Dropdown, { onApply: this.onApply, onCancel: onCancel, operator: (filter && sdk_model_1.measureValueFilterOperator(filter)) || null, value: (filter && getFilterValue(filter)) || null, usePercentage: usePercentage, warningMessage: warningMessage, locale: locale, anchorEl: anchorEl, separators: separators, displayTreatNullAsZeroOption: displayTreatNullAsZeroOption, treatNullAsZeroValue: getTreatNullAsZeroValue(filter, treatNullAsZeroDefaultValue), enableOperatorSelection: enableOperatorSelection }));
    };
    MeasureValueFilterDropdown.defaultProps = {
        displayTreatNullAsZeroOption: false,
        treatNullAsZeroDefaultValue: false,
        enableOperatorSelection: true,
    };
    return MeasureValueFilterDropdown;
}(react_1.default.PureComponent));
exports.MeasureValueFilterDropdown = MeasureValueFilterDropdown;
//# sourceMappingURL=MeasureValueFilterDropdown.js.map